<template>
    <div>
        <input
            ref="input"
            class="d-none"
            type="file"
            @change="onChange"
        >
        <slot :clickHandler="open">
            <button class="btn btn-purple" >Select a file</button>
        </slot>
    </div>
</template>

<script>
  export default {
    methods: {
      /**
       * @return {undefined}
       */
      open() {
        this.$refs.input.click();
      },

      /**
       * @return {undefined}
       */
      onChange() {
        this.emitValue();
      },

      /**
       * @event input
       * @type {File}
       */
      emitValue() {
        this.$emit('input',_.head(this.$refs.input.files));
      },
    },
  }
</script>

